import { render, staticRenderFns } from "./AsideMenuListPlain.vue?vue&type=template&id=555b8949&scoped=true&"
import script from "./AsideMenuListPlain.vue?vue&type=script&lang=js&"
export * from "./AsideMenuListPlain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555b8949",
  null
  
)

export default component.exports